import React from 'react';

import { CollapseContainer } from './styles';

const CollapseCard = ({ isOpen, children }) => (
  <CollapseContainer isOpen={isOpen}>{children}</CollapseContainer>
);

export default CollapseCard;
